import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsx } from 'react/jsx-runtime';
import noop from 'lodash/noop';
import { useState, useCallback, useMemo, createContext, useContext } from 'react';
import { useScrollState } from './use-scroll-state.js';
var HorizontalScrollContext = /*#__PURE__*/createContext({
  scrollPosition: 'none',
  scrollLeft: noop,
  scrollRight: noop,
  onAttach: noop
});

var HorizontalScrollProvider = function HorizontalScrollProvider(_ref) {
  var children = _ref.children,
      _ref$scrollStep = _ref.scrollStep,
      scrollStep = _ref$scrollStep === void 0 ? 50 : _ref$scrollStep;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      scrollableElement = _useState2[0],
      setScrollableElement = _useState2[1];

  var _useScrollState = useScrollState(scrollableElement, scrollStep),
      scrollPosition = _useScrollState.scrollPosition,
      scrollLeft = _useScrollState.scrollLeft,
      scrollRight = _useScrollState.scrollRight;

  var onAttach = useCallback(function (node) {
    setScrollableElement(node);
  }, []);
  var contextValue = useMemo(function () {
    return {
      scrollPosition: scrollPosition,
      scrollLeft: scrollLeft,
      scrollRight: scrollRight,
      onAttach: onAttach
    };
  }, [scrollPosition, scrollLeft, scrollRight, onAttach]);
  return jsx(HorizontalScrollContext.Provider, {
    value: contextValue,
    children: children
  });
};

var useScrollContext = function useScrollContext() {
  var context = useContext(HorizontalScrollContext);

  if (!context) {
    throw new Error('useScrollContext must be used within a HorizontalScrollProvider');
  }

  return context;
};

export { HorizontalScrollProvider, useScrollContext };